/** Gửi một sự kiện GA4 cho mỗi phản hồi đăng ký thành công, không gửi dữ liệu form. */
export function trackRegistrationSuccess(formName, onComplete) {
    let completed = false;
    const finish = () => {
        if (completed) return;
        completed = true;
        if (onComplete) onComplete();
    };
    if (onComplete) window.setTimeout(finish, 2000);

    const parameters = {
        send_to: 'G-H8TV93F0DS',
        form_name: formName,
        page_location: window.location.origin + window.location.pathname,
        page_referrer: document.referrer.split(/[?#]/)[0],
        event_callback: finish,
        event_timeout: 2000,
    };

    try {
        window.dataLayer = window.dataLayer || [];
        const gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        gtag('event', 'popup_form_dk', parameters);
    } catch (error) {
        // Tracking không được chặn thông báo thành công hoặc chuyển trang.
        finish();
    }
}
